<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header
        entity="unit"
        :edit="edit"
        :save="save"
        :cancel="cancel"
        :remove="remove"
      >
        <h1 class="title">
          <breadcrumb
            location="/units"
            :text="$t('entities.unit')"
          ></breadcrumb>
          {{ unit.name }}
        </h1>
      </page-header>
      <div class="panel">
        <div class="panel-heading has-background-primary">
          <span>{{ $t("common.information") }}</span>
        </div>
        <div class="panel-block is-block no-border">
          <div class="columns">
            <div class="column is-half" v-if="unit">
              <text-field
                :label="$t('common.name')"
                v-model="unit.name"
                required
              />
              <text-field
                :label="$t('common.oracleCode')"
                v-model="unit.oracleCode"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "unit",
  props: ["id"],
  data() {
    return {
      unit: {
        name: null,
        oracleCode: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      editMode: "states/isEdition",
      getRights: "auth/getRights",
      user: "auth/getUser",
    }),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return axios.get(`/unit/${this.id}`).then((r) => {
        this.unit = r.data;
      });
    },
    remove() {
      return this.$awn.confirm(
        "Êtes-vous sûr de vouloir supprimer cet élément ?",
        () =>
          axios.delete(`/unit/${this.id}`, this.unit).then((response) => {
            if (response.data.success) {
              this.$router.replace("/units");
            }
          })
      );
    },
    save() {
      return this.$validator.validateAll().then((result) => {
        if (result) {
          return axios.put(`/unit/${this.id}`, this.unit).then((response) => {
            if (response.data.success) {
              this.cancel();
            }
          });
        }
        return Promise.resolve();
      });
    },
    edit() {
      this.$store.dispatch("states/setEdition", true);
    },
    cancel() {
      this.fetchData().then(() => {
        this.$store.dispatch("states/setEdition", false);
      });
    },
  },
};
</script>
